import React from 'react';
import {
  Container,
  Wrapper,
  Label,
  Input,
  ErrorMessage,
} from '../styles/FormControl.styled';

const FormControl = ({
  id,
  type,
  name,
  label,
  placeholder,
  autoComplete,
  errorMessage,
  value,
  handleChange,
  hidden,
}) => (
  <Container className={`custom-form-control control-${name}`} hidden={hidden}>
    <Wrapper>
      <Label htmlFor={name}>{label || name}</Label>
      <Input
        id={id}
        type={type}
        name={name}
        placeholder={placeholder}
        autoComplete={autoComplete}
        value={value}
        className={errorMessage ? 'error' : ''}
        onChange={e => handleChange(e)}
      />
    </Wrapper>
    {errorMessage && (
      <ErrorMessage dangerouslySetInnerHTML={{ __html: errorMessage }} />
    )}
  </Container>
);

export default FormControl;
